import axios from "axios";
import { url } from './utils/config';

const publicKey = 'BD7CO0OzMWoCW7wcLUw4Y828Ru6JzayUq2ycy9wCuplYAEO_9XdI-6pjpTVK9VdiCRr1li9KEqvW3ie3OoNGCDw';

export default async function registerServiceWorker() {
    if('serviceWorker' in navigator) {
        const swUrl = `${process.env.PUBLIC_URL}/sw.js`
        try {
            console.log('registering Service Worker.');

            const registration = await navigator.serviceWorker.register(swUrl);

            console.log('Service Worker registered.');
            console.log('Subscribing to Push Service')

            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(publicKey)
            })

            console.log('Subscribed to Push Service.');
            console.log('Sending Subscription Data..');

            const reqUrl = url + '/subscribe';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const response = await axios.post(reqUrl, subscription, { headers });
            // window.localStorage.setItem('worker', 'connected')

        } catch (error) {
            console.log(error);
        }
    } else {
        console.log('Unable to register service worker..!');
    }
}

function urlBase64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}